/* eslint-disable */
import * as types from './action_types';
import Immutable from 'immutable';

export const initialState = Immutable.fromJS({
  loading: false,
  error: undefined,
  comments: []
});

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.WORD_COMMENTS_RESET:
      return initialState;
    case types.WORD_COMMENTS_RETRIEVING:
      return state.merge({ loading: true });
    case types.WORD_COMMENTS_RETRIEVED:
      return state.merge({ loading: false, error: undefined, comments: action.comments });
    case types.WORD_COMMENT_SAVED:
      if (action.isNew) {
        const newComments = addToComments(state.get('comments'), action.comment);
        return state.merge({ loading: false, error: undefined, comments: newComments});
      } else {
        const updatedComments = updateComments(state.get('comments'), action.comment);
        return state.merge({ loading: false, error: undefined, comments: updatedComments });
      }
    case types.WORD_COMMENTS_ERROR:
      return state.merge({ error: action.error, loading: false });
    default:
      return state;
  }
}

const addToComments = (immutableComments, comment) => {
  let newComments = immutableComments.toJS();
  newComments.splice(0, 0, comment)
  return newComments;
}

const updateComments = (immutableComments, updatedComment) => {
  const comments = immutableComments.toJS();
  return comments.map((comment) => {
    if (comment.slug !== updatedComment.slug) {
      return comment;
    }
    return {
      ...updatedComment
    };
  });
}



// WEBPACK FOOTER //
// ./src/stores/word_comments/reducer.js